import _ from 'lodash';

type permissionsType = { 
    pillars: string[],
    roles: string[]
 }

export function oldSideNavPermissions(permissions: permissionsType, pillar: string, token){
    
    const { pillars, roles } = permissions

    let pillarVerify = _.find(pillars, o => { return o === pillar })

        if (pillarVerify != pillar) {
          return false;
        }

        let groups = token['cognito:groups']

        if (roles.length) {
          return roles.find(e => { return roles.indexOf(e) != -1; }) != null;
        }
        if (groups) {
          return roles.find(e => { return groups.indexOf(e) != -1; }) != null;
        }
        return false;
}

export function oldPagePermissions(type: string[], roles: string[]){
  let accept = false;
    let Allowedroles = {}

    roles.forEach(r => Allowedroles[r])

    for(let t of type){
        if(Allowedroles[t]){
            accept = true;
            break;
        }
    }

    return accept;
}